import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/constant';

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({}); 
    const [apiError, setApiError] = useState(''); 
    const [loading, setLoading] = useState(false); 

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
      
        if (errors[e.target.name]) {
            setErrors(prevErrors => ({ ...prevErrors, [e.target.name]: '' }));
        }
        setApiError('');
    };

    const validateForm = () => {
        const newErrors = {};
        if (!form.email.trim()) {
            newErrors.email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(form.email)) {
            newErrors.email = 'Email is invalid.';
        }
        if (!form.password) {
            newErrors.password = 'Password is required.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; 
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setApiError(''); 
        setErrors({}); 

        if (!validateForm()) {
            return; 
        }

        setLoading(true);
        try {
            
            const res = await fetch(`${API_BASE_URL}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });
            const data = await res.json();

            if (!res.ok) {
                if (data.errors) {
                    setErrors(data.errors);
                } else {
                    setApiError(data.message || 'Login failed. Please check your credentials.');
                }
                throw new Error(data.message || 'Login failed');
            }

            login(data); 
            navigate('/application'); 
        } catch (err) {
            if (!Object.keys(errors).length) { 
                setApiError(err.message || 'Network error. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-32 mb-20 p-6 border shadow">
            <h2 className="text-2xl font-semibold mb-4 overflow-hidden">Login</h2>
            {apiError && <p className="text-red-500 mb-4">{apiError}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Email"
                        className={`w-full p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>
                <div>
                    <input
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Password"
                        className={`w-full p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
                </div>
                <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                >
                    {loading ? 'Logging in...' : 'Login'}
                </button>

                {/* <div className='flex gap-2'>
                    <p>Don't have an account ?</p>
                    <Link to="/signup" className='text-blue-500 hover:underline'>SignUp</Link>
                </div> */}
            </form>
        </div>
    );
}